import { Box, Button, Checkbox, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import S3 from 'react-aws-s3'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { updateAlert, getPrintFormatList, getCurrentFormatDetails,saveWaybillDetail } from '../../../../../store/common/common_action'
import { focusElemnt, navigation1, navigation3,appendToUrl, getPhone } from '../../../../common/helper'
import { connect } from 'react-redux'
import ImageUploader from '../../../../common/uploadImage'
import DropDownOA from '../../../../common/dropDownOA'
import LineinputV2 from '../../../../common/lineinputV2'
import { ReactS3ClientConfig } from '../../../../../Utils/ReactS3Client'
import useToken from '../../../../helpers/useTokens'
const StandardTicketFormatAndLogo = (props) => {
  const { data, updateModal, updateAlert, getPrintFormatList, getCurrentFormatDetails, saveWaybillDetail } = props
  const { common } = data
  const { waybillFormats, selectedFormatDetail } = common
  const {loginData}= useToken()
  const [helplineNumber, setHelplineNumber] = useState('')
  const [website, setWebsite] = useState('')
  const [rulesText, setRulesText] = useState('')
  const [declarationText, setDeclarationText] = useState('')
  const [logoCheck,setLogoCheck]=useState(false)
  const [helpLineCheck,setHelpLineCheck]=useState(false)
  const [websiteCheck,setWebsiteCheck]=useState(false)
  const [bookingDelcareCheck,setBookinDeclareCheck]=useState(false)
  const [deliveryDeclareCheck,setDelivryDeclareCheck]=useState(false)
  const [logoFile,setLogofile]=useState(false)

  const [selectedWayBill, setSelectedWayBillFormat] = useState(waybillFormats[0])
  const [selectedFormtatData,setSelectedFormatData] = useState(selectedFormatDetail)

  const RULES_MAX_LENGTH = 10000;
  const DECLARATION_MAX_LENGTH_BOOKING = 1000;
  const DECLARATION_MAX_LENGTH_DELIVERY = 1000;

  useEffect(() => {
    focusElemnt('chooseLogo')
  }, [])
  useEffect(() => {
    if (loginData.intCompanyID) {
      getPrintFormatList(loginData.intCompanyID)
    }
  }, [loginData.intCompanyID])
  useEffect(()=>{
    if(Array.isArray(waybillFormats)&&waybillFormats.length){
      setSelectedWayBillFormat(waybillFormats[0])
    }
  },[waybillFormats])
  useEffect(() => {
    if (selectedFormatDetail && Object.getPrototypeOf(selectedFormatDetail) === Object.prototype) {
      setSelectedFormatData(selectedFormatDetail)
    }
  }, [selectedFormatDetail])
  const uploadToS3 = async (file) => {
    const ReactS3Client = new S3({ ...ReactS3ClientConfig, bucketName: 'mantisdocs' })
    const fileType = file.name.split('.').pop()
    const fileName = `crscompanylogo/CargoLogo_${loginData.intCompanyID}_${selectedWayBill?.FormatID}.${fileType}`
    const rs = await ReactS3Client.uploadFile(file, fileName)
      .then((data) => {
        return data.location
      })
      .catch((err) => console.error(err))
    return rs
  }
  const handleLogoUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (event) => {
        const img = new Image()
        img.src = event.target.result
        img.onload = () => {
          // Check the dimensions of the uploaded logo
          if (img.width <= 387 && img.height <= 103) {
            // Check the size of the uploaded logo
            if (file.size <= 10 * 1024 * 1024) {
              setSelectedFormatData({ ...selectedFormtatData, LogoUrl: event.target.result })
              setLogofile(file)
            } else {
              handleAlert('Logo size should be less than or equal to 10MB.')
            }
          } else {
            handleAlert('Logo dimensions should be less than or equal to 387x103 pixels.')
          }
        }
      }
      reader.readAsDataURL(file)
      focusElemnt('helpLineNo')
    }
  }
  const handleAlert = (msg = false, nextId = '') => {
    if (!(msg instanceof Event)) {
      if (msg) {
        updateAlert({ show: true, msg })
      } else {
        updateAlert({ show: false, msg: '' })
        focusElemnt(nextId)
      }
    }
  }
  const handleRules = (e) => {
    let inputValue = e.target.value
    if (inputValue.length > RULES_MAX_LENGTH) {
      handleAlert(`Rules & Regulations should not exceed ${RULES_MAX_LENGTH} characters.`, 'rulesInput')
      inputValue = inputValue.slice(0, RULES_MAX_LENGTH)
    }
    setSelectedFormatData({ ...selectedFormtatData, RulesAndRegulations: inputValue })
  }

  const handleDeclaration = (e, isDel = false) => {
    const inputName = isDel ? 'DeclarationDelivery' : 'DeclarationBooking'
    const maxLength = isDel ? DECLARATION_MAX_LENGTH_DELIVERY : DECLARATION_MAX_LENGTH_BOOKING
    let inputValue = e.target.value
    if (inputValue.length > maxLength) {
      handleAlert(
        `Declaration on LR ${isDel ? 'Delivery' : 'Booking'} should not exceed ${maxLength} characters.`,
        `declaration-${isDel ? 'delivery' : 'booking'}`
      )
      inputValue = inputValue.slice(0, maxLength)
    }
    setSelectedFormatData({ ...selectedFormtatData, [inputName]: inputValue })
  }
  const handleSave = () => {
    if (logoFile) {
      uploadToS3(logoFile).then((res) => {
        saveWaybillDetail({ ...selectedFormtatData, LogoUrl: res,IsRulesAndRegulations:1 })
        
        getCurrentFormatDetails({ CompanyID: loginData.intCompanyID, FormatID: selectedWayBill?.FormatID })
      })
    } else {
      saveWaybillDetail({ ...selectedFormtatData,CompanyID:loginData.intCompanyID,FormatID: selectedWayBill?.FormatID,IsRulesAndRegulations:1  })
      getCurrentFormatDetails({ CompanyID: loginData.intCompanyID, FormatID: selectedWayBill?.FormatID })
    }
  }
  const previewticket = (isDelivery=false) => {
    const urlData = {
      l: selectedFormtatData.IsLogo,
      h: +helpLineCheck,
      w: +websiteCheck,
      d: isDelivery ? +deliveryDeclareCheck : +bookingDelcareCheck,
      dl: +isDelivery,
    }
    let url = '/preview'
    if(selectedWayBill?.FormatID === 2){
      url = appendToUrl(url+'?page=thermal&', urlData)
    }else{
      url = appendToUrl(url + '?page=laser' + (selectedWayBill?.FormatID )+'&dl='+ +isDelivery)
    }
    window.open(url, '_blank')
  }


  return (
    <>
      <Box>
        <Box style={{ display: 'flex', paddingTop: '10px' }}>
          <Box sx={{ paddingRight: '8px' }} className={'input--wrapper'}>
            <DropDownOA
              label={'Select Waybill Fomat'}
              data={waybillFormats}
              dataKey={'FormatName'}
              width="400px"
              defaultvalue={selectedWayBill?.FormatName}
              value={selectedWayBill?.FormatName}
              idKey={`FormatID`}
              onSelect={(waybill) => setSelectedWayBillFormat(waybill)}
            />
          </Box>
          <Box sx={{ paddingRight: '8px' }} className={'input--wrapper'}>
            <Button
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp, height: '40px' }}
              className="btn btn-primary"
              onClick={() => {
                setLogofile(false)
                getCurrentFormatDetails({ CompanyID: loginData.intCompanyID, FormatID: selectedWayBill?.FormatID })}
              }
            >
              GO
            </Button>
          </Box>
          {selectedFormatDetail && (
            <>
              <Checkbox
                sx={{ height: '40px' }}
                disabled={selectedWayBill?.FormatID !== 2}
                checked={selectedWayBill?.FormatID !== 2 || selectedFormtatData.IsLogo === 1}
                onChange={() => setSelectedFormatData({ ...selectedFormtatData, IsLogo: selectedFormtatData.IsLogo === 1 ? 0 : 1 })}
              />
              <Box sx={{ paddingRight: '8px' }} className={'input--wrapper'}>
                <ImageUploader
                  onLogoUpload={handleLogoUpload}
                  logoFile={selectedFormtatData.LogoUrl}
                  chooseFileLabel="Upload Logo (Image Size: 387 x 103 Px)"
                  //chooseFileBorder="1px solid red"
                />
              </Box>
              <Checkbox
                sx={{ height: '40px' }}
                disabled={selectedWayBill?.FormatID !== 2}
                checked={selectedWayBill?.FormatID !== 2 || selectedFormtatData.IsHelpline === 1}
                onChange={() => setSelectedFormatData({ ...selectedFormtatData, IsHelpline: selectedFormtatData.IsHelpline === 1 ? 0 : 1 })}
              />
              <Box sx={{ paddingRight: '8px' }} className={'input--wrapper'}>
                <LineinputV2
                  id={'helpLineNo'}
                  label={`Helpline No.`}
                  type="text"
                  name="Helpline No."
                  value={selectedFormtatData.Helpline || ''}
                  sx={{ margin: '8px', width: '100%' }}
                  onBlur={(e) => {
                    setSelectedFormatData({ ...selectedFormtatData, Helpline: e.target.value })
                  }}
                  filter={(val)=>getPhone(val,12)}
                  icon="crossIcon"
                  onKeyDown={(e) => navigation1(e, 'website', 'chooseLogo')}
                />
              </Box>
              <Checkbox
                sx={{ height: '40px' }}
                disabled={selectedWayBill?.FormatID !== 2}
                checked={selectedWayBill?.FormatID !== 2 || selectedFormtatData.IsWebsite === 1}
                onChange={() => setSelectedFormatData({ ...selectedFormtatData, IsWebsite: selectedFormtatData.IsWebsite === 1 ? 0 : 1 })}
              />
              <Box sx={{ paddingRight: '8px' }} className={'input--wrapper'}>
                <LineinputV2
                  id={'website'}
                  label={`Website`}
                  type="text"
                  name="Website"
                  value={selectedFormtatData.Website || ''}
                  sx={{ margin: '8px', width: '100%' }}
                  onBlur={(e) => setSelectedFormatData({ ...selectedFormtatData, Website: e.target.value })}
                  icon="crossIcon"
                  onKeyDown={(e) => navigation1(e, 'rulesInput', 'helpLineNo')}
                />
              </Box>
            </>
          )}
        </Box>
        {selectedFormatDetail && (
          <>
            <Box style={{ display: 'flex', paddingTop: '10px' }}>
              <label
                style={{
                  display: 'flex',
                  fontSize: '14px',
                  color: '#0086FF',
                  fontWeight: '600',
                  fontFamily: 'Roboto',
                  // paddingTop: '16px',
                  lineHeight: '16px',
                  alignItems: 'center',
                  textDecoration: 'underline',
                  textTransform: 'uppercase',
                }}
                onClick={() => previewticket()}
              >
                View Booking Template
              </label>
              <label
                style={{
                  display: 'flex',
                  fontSize: '14px',
                  color: '#0086FF',
                  fontWeight: '600',
                  fontFamily: 'Roboto',
                  // paddingTop: '16px',
                  lineHeight: '16px',
                  alignItems: 'center',
                  textDecoration: 'underline',
                  marginLeft: '16px',
                  marginRight: '16px',
                  textTransform: 'uppercase',
                }}
                onClick={() => previewticket(true)}
              >
                View Delivery Template
              </label>
            </Box>
            <div style={{ textAlign: 'center', paddingBottom: '10px' }}>
              <Box style={{ display: 'flex', alignItems: 'center', paddingTop: '16px' }}>
                <Checkbox sx={{ padding: 0, marginRight: '10px' }} disabled={true} checked={true} />
                <label style={{ display: 'flex', fontSize: '16px', color: '#444444', fontWeight: '500', fontFamily: 'Roboto' }}>
                  Rules & Regulations - On LR Booking Print
                  <span style={{ fontSize: '12px', color: '#0086ff', marginLeft: '10px', lineBreak: '25px' }}>
                    {' '}
                    (* Max Limit {RULES_MAX_LENGTH} Characters )
                  </span>
                </label>
              </Box>

              <textarea
                className="ticket-textarea"
                id="rulesInput"
                name="rulesInput"
                value={selectedFormtatData.RulesAndRegulations || ''}
                onChange={(e) => handleRules(e)}
                rows="10"
                placeholder="Type Your Rules and Regulations here..."
                style={{
                  width: '100%',
                  boxSizing: 'border-box',
                  borderRadius: '6px',
                  borderColor: '#00000026',
                  padding: '15px',
                  fontFamily: 'Roboto',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#444444',
                  // borderColor: borderColor,
                }}
                onKeyDown={(e) => navigation1(e, 'declaration', 'website')}
                // onFocus={handleFocus}
                // onBlur={handleBlur}
              />
              <Box style={{ display: 'flex', alignItems: 'center', paddingTop: '16px' }}>
                <Box sx={{ flex: 1, paddingRight: '10px' }}>
                  <Box style={{ display: 'flex', alignItems: 'center', paddingTop: '16px' }}>
                    <Checkbox
                      sx={{ padding: 0, marginRight: '10px' }}
                      disabled={selectedWayBill?.FormatID !== 2}
                      checked={selectedWayBill?.FormatID !== 2 || selectedFormtatData.IsDeclarationBooking === 1}
                      onChange={() =>
                        setSelectedFormatData({
                          ...selectedFormtatData,
                          IsDeclarationBooking: selectedFormtatData.IsDeclarationBooking === 1 ? 0 : 1,
                        })
                      }
                    />
                    <label style={{ display: 'flex', fontSize: '16px', color: '#444444', fontWeight: '500', fontFamily: 'Roboto' }}>
                      Declaration- On LR Booking Slip
                      <span style={{ fontSize: '12px', color: '#0086ff', marginLeft: '10px', lineBreak: '25px' }}>
                        ( * Max Limit {DECLARATION_MAX_LENGTH_BOOKING} Characters )
                      </span>
                    </label>
                  </Box>
                  <textarea
                    id={'declaration-booking'}
                    className="ticket-textarea"
                    value={selectedFormtatData.DeclarationBooking || ''}
                    // onChange={(e) => setDeclarationText(e.target.value)}
                    onChange={(e) => handleDeclaration(e)}
                    rows="10"
                    placeholder="Type Your Declaration here..."
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      borderRadius: '6px',
                      borderColor: '#00000026',
                      padding: '15px',
                      fontFamily: 'Roboto',
                    }}
                    onKeyDown={(e) => navigation1(e, 'save_btn', 'rulesInput')}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Box style={{ display: 'flex', alignItems: 'center', paddingTop: '16px' }}>
                    <Checkbox
                      sx={{ padding: 0, marginRight: '10px' }}
                      disabled={selectedWayBill?.FormatID !== 2}
                      checked={selectedWayBill?.FormatID !== 2 || selectedFormtatData.IsDeclarationDelivery === 1}
                      onChange={() =>
                        setSelectedFormatData({
                          ...selectedFormtatData,
                          IsDeclarationDelivery: selectedFormtatData.IsDeclarationDelivery === 1 ? 0 : 1,
                        })
                      }
                    />
                    <label style={{ display: 'flex', fontSize: '16px', color: '#444444', fontWeight: '500', fontFamily: 'Roboto' }}>
                      Declaration - On LR Delivery Slip
                      <span style={{ fontSize: '12px', color: '#0086ff', marginLeft: '10px', lineBreak: '25px' }}>
                        ( * Max Limit {DECLARATION_MAX_LENGTH_DELIVERY} Characters )
                      </span>
                    </label>
                  </Box>
                  <textarea
                    id={'declaration-delivery'}
                    className="ticket-textarea"
                    value={selectedFormtatData.DeclarationDelivery || ''}
                    onChange={(e) => handleDeclaration(e, true)}
                    rows="10"
                    placeholder="Type Your Declaration here..."
                    style={{
                      width: '100%',
                      boxSizing: 'border-box',
                      borderRadius: '6px',
                      borderColor: '#00000026',
                      padding: '15px',
                      fontFamily: 'Roboto',
                    }}
                    onKeyDown={(e) => navigation1(e, 'save_btn', 'rulesInput')}
                  />
                </Box>
              </Box>
            </div>
            <Divider />
            <Box sx={{ display: 'flex', float: 'right', padding: '12px' }} className="itemButtons">
              <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
                <Button
                  variant="outlined"
                  id={'new_add_btn'}
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  // onClick={() => {
                  //   updateModal(true, mdt.deliveryChrgModal)
                  // }}
                  // onKeyDown={(e) => navigation3(e, 'Booking_Type', 'load_btn', () => {})}
                >
                  CANCEL
                </Button>
              </Item>
              <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
                <Button
                  variant="contained"
                  id={'save_btn'}
                  sx={{ paddingY: '7px !important', height: '37px' }}
                  className="btn btn-primary"
                  onClick={() => handleSave()}
                  onKeyDown={(e) => navigation3(e, 'helpLineNo', 'declaration', () => {})}
                >
                  SAVE
                </Button>
              </Item>
            </Box>
          </>
        )}
      </Box>
    </>
  )
}

// export default StandardTicketFormatAndLogo
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlert, getPrintFormatList, getCurrentFormatDetails,saveWaybillDetail }
export default connect(mapStateToProps, mapDispatchToProps)(StandardTicketFormatAndLogo)
